import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pago-seguimiento',
  templateUrl: './pago-seguimiento.component.html',
  styleUrls: ['./pago-seguimiento.component.scss']
})
export class PagoSeguimientoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
